@if (isAuthenticated()) {
  <section class="my-account-navigation">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="links">
            <a routerLink="/dashboard/edit-profile">PROFILUL MEU</a>
            <a routerLink="/dashboard" class="active">EVENIMENTE</a>
          </div>

          <div class="dropdown d-md-none">
            <div class="dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
              Evenimente
            </div>
            <ul class="dropdown-menu">
              <li><a class="dropdown-item" routerLink="/dashboard/edit-profile">PROFILUL MEU</a></li>
              <li><a class="dropdown-item" routerLink="/dashboard">Evenimente</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>
}

<section class="my-account">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="back-button">
          <a (click)="goBack()" class="it-back-button cursor-pointer">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <g clip-path="url(#clip0_276_18)">
                <path d="M13.5 8H2.5" stroke="#7F7F7F" stroke-width="1.5" stroke-linejoin="round"/>
                <path d="M7 3.5L2.5 8L7 12.5" stroke="#7F7F7F" stroke-width="1.5" stroke-linejoin="round"/>
              </g>
              <defs>
                <clipPath id="clip0_276_18">
                  <rect width="16" height="16" fill="white"/>
                </clipPath>
              </defs>
            </svg>
            ÎNAPOI
          </a>
        </div>

        <ui-title-block title="EVENIMENTE VIITOARE" />

        @if (eventsResource.isLoading()) {
          <div class="d-flex justify-content-center py-5">
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Se încarcă...</span>
            </div>
          </div>
        } @else if (eventsResource.error()) {
          <div class="alert alert-danger" role="alert">
            Eroare la încărcarea evenimentelor. Vă rugăm să încercați mai târziu.
          </div>
        } @else {
          <div class="events-list">
            @for (event of events(); track event.id) {
              <ui-event-card
                [name]="event.name"
                [year]="event.year.toString()"
                [date]="event.date_start | date:'dd.MM.yyyy'"
                [image]="event.logo"
                [isPast]="event.is_past"
                [isRegistered]="event.isRegistered"
                [isUserParticipant]="event.isUserParticipant"
                [additionalParticipantsCount]="event.additionalParticipantsCount"
                [confirmedParticipants]="event.confirmedParticipants"
                [confirmedSupporters]="event.confirmedSupporters"
                [pendingParticipants]="event.pendingParticipants"
                [pendingSupporters]="event.pendingSupporters"
                [cancelledParticipants]="event.cancelledParticipants"
                [cancelledSupporters]="event.cancelledSupporters"
                [status]="event.displayStatus"
                [link]="['/dashboard/events', event.id]"
                [registerLink]="['/events', event.id, 'register']"
                [canRegister]="event.is_registration_open"
                [rulesLink]="event.rules_link"
                [externalLink]="event.config?.external_event_url"
                [participantTitle]="event.config?.participant_title || 'Participant'"
                [participantTitlePlural]="event.config?.participant_title_plural || 'Participanți'"
                [pricingSummary]="event.pricing_summary"
              />
            } @empty {
              <div class="alert alert-info py-4 text-center">
                Momentan nu există evenimente programate.
              </div>
            }
          </div>
        }
      </div>
    </div>
  </div>
</section>
